import styles from "@store/Components/Store/StoreSchematicsView/styles";
import { css } from "styled-components";

Object.assign(styles, {
    addProductBodyGridCell: {
        ...styles.addProductBodyGridCell,
        css: css`
            ${styles.addProductBodyGridCell?.css ?? ""}
            display: flex;
            gap: 0.5em;
            align-items: center;
        `
    },
    mobileAddProductBodyGridCell: {
        ...styles.mobileAddProductBodyGridCell,
        css: css`
            ${styles.mobileAddProductBodyGridCell?.css ?? ""}
            display: flex;
            flex-direction: column;
            gap: 0.5em;
            align-items: start;
        `
    }
})